// src/components/Header.js
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Header = () => {
  const location = useLocation();
  const { currentUser, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <header className="bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 text-white shadow-2xl">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-4">
            <div className="bg-white bg-opacity-10 p-2 rounded-lg backdrop-blur-sm">
              <div className="text-2xl">🚀</div>
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                VentES AI Dashboard
              </h1>
              <p className="text-sm text-blue-200 opacity-80">VentES Ecosystem Hub</p>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex items-center space-x-2">
            {currentUser && (
              <>
                <Link to="/">
                  <button className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                    location.pathname === '/'
                      ? 'bg-white bg-opacity-20 text-white shadow-lg backdrop-blur-sm'
                      : 'text-blue-200 hover:bg-white hover:bg-opacity-10 hover:text-white'
                  }`}>
                    <span className="flex items-center space-x-2">
                      <span>🏠</span>
                      <span>Dashboard</span>
                    </span>
                  </button>
                </Link>
                <Link to="/manage-apps">
                  <button className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                    location.pathname === '/manage-apps'
                      ? 'bg-white bg-opacity-20 text-white shadow-lg backdrop-blur-sm'
                      : 'text-blue-200 hover:bg-white hover:bg-opacity-10 hover:text-white'
                  }`}>
                    <span className="flex items-center space-x-2">
                      <span>⚙️</span>
                      <span>Manage Apps</span>
                    </span>
                  </button>
                </Link>
                <Link to="/actions">
                  <button className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                    location.pathname === '/actions'
                      ? 'bg-white bg-opacity-20 text-white shadow-lg backdrop-blur-sm'
                      : 'text-blue-200 hover:bg-white hover:bg-opacity-10 hover:text-white'
                  }`}>
                    <span className="flex items-center space-x-2">
                      <span>✓</span>
                      <span>Actions</span>
                    </span>
                  </button>
                </Link>
                {currentUser.can_manage_agents && (
                  <Link to="/agent-connections">
                    <button className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                      location.pathname === '/agent-connections'
                        ? 'bg-white bg-opacity-20 text-white shadow-lg backdrop-blur-sm'
                        : 'text-blue-200 hover:bg-white hover:bg-opacity-10 hover:text-white'
                    }`}>
                      <span className="flex items-center space-x-2">
                        <span>🔌</span>
                        <span>AI Connections</span>
                      </span>
                    </button>
                  </Link>
                )}
              </>
            )}

            {/* User Menu */}
            {currentUser ? (
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center space-x-3 px-4 py-2 rounded-lg font-medium transition-all duration-200 text-blue-200 hover:bg-white hover:bg-opacity-10 hover:text-white"
                >
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full flex items-center justify-center text-white font-semibold">
                    {currentUser.name?.charAt(0) || currentUser.email.charAt(0).toUpperCase()}
                  </div>
                  <span className="hidden md:block">
                    {currentUser.name || currentUser.email.split('@')[0]}
                  </span>
                  <span className="text-xs">▼</span>
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-50">
                    <div className="py-2">
                      <div className="px-4 py-2 border-b border-gray-200">
                        <p className="text-sm font-medium text-gray-900">
                          {currentUser.name}
                        </p>
                        <p className="text-xs text-gray-500">{currentUser.email}</p>
                        {currentUser.organization_name && (
                          <p className="text-xs text-gray-400">{currentUser.organization_name}</p>
                        )}
                      </div>
                      <button
                        onClick={() => {
                          logout();
                          setShowUserMenu(false);
                        }}
                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        🚪 Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login">
                <button className="px-4 py-2 rounded-lg font-medium transition-all duration-200 bg-blue-600 hover:bg-blue-700 text-white">
                  Sign In
                </button>
              </Link>
            )}
          </nav>
        </div>
      </div>

      {/* Subtle bottom border with gradient */}
      <div className="h-1 bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-30"></div>
    </header>
  );
};

export default Header;
